import React from 'react'

interface PurpleWaveLogoProps {
    className?: string
}

export default function PurpleWaveLogo({ className = '' }: PurpleWaveLogoProps) {
    return (
        <svg className={className} viewBox="0 0 242.53 228.45" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Layer_2_Image" data-name="Layer 2 Image">
                <path
                    className="fill-[#4f2682]"
                    d="M231.75,80c-3.68-2.68-6.08-6.57-9.28-9.85C201,48.2,168.66,30.5,126.26,29.62c-47.38-1-84.82,14.8-114.93,32.62-2.47,1.47-8.42,4.11-10.87,6C26.63,46.34,57.62,24.18,93.92,10.78c18.53-6.85,41-12,64.69-10.14C203.39,4.22,228.9,33.88,231.75,80Z"
                    transform="translate(-0.46 -0.25)"
                />
                <path
                    className="fill-[#929497]"
                    d="M38.27,219.12H18.46l-3.54,9.2H12l15-37.69h2.89q7.55,18.84,15,37.69h-3Zm-10-25.4c-.89,2.33-7.87,20.36-9,23.18H37.44l-5.32-13.76c-1.24-3.14-2.48-6.28-3.67-9.42Z"
                    transform="translate(-0.46 -0.25)"
                />
                <path
                    className="fill-[#929497]"
                    d="M77.75,190.63v25.13c0,7.8-5.91,12.89-14.13,12.89-8.45,0-14.06-5.53-14.06-13.27V190.63h2.72v24.15c0,6.39,4.37,11.49,11.34,11.49,6.63,0,11.3-4.12,11.3-11.05V190.63Z"
                    transform="translate(-0.46 -0.25)"
                />
                <path
                    className="fill-[#929497]"
                    d="M111.74,221.07c-2.07,4.65-6.68,7.63-12.88,7.63-9.76,0-14.19-6.33-14.19-13.7V203.79c0-7.2,4.67-13.43,14.19-13.43,6.08,0,10.58,2.82,12.7,7l-2.48,1.14c-1.65-3.36-5.26-5.85-10.17-5.85-7.74,0-11.52,5.2-11.52,11.21v11.16c0,6,3.78,11.31,11.52,11.31A10.89,10.89,0,0,0,109.26,220Z"
                    transform="translate(-0.46 -0.25)"
                />
                <path
                    className="fill-[#929497]"
                    d="M128.35,192.85v35.47h-2.72V192.85H113.22v-2.22h27.37v2.22Z"
                    transform="translate(-0.46 -0.25)"
                />
                <path
                    className="fill-[#929497]"
                    d="M145.91,228.32V190.63h2.72v37.69Z"
                    transform="translate(-0.46 -0.25)"
                />
                <path
                    className="fill-[#929497]"
                    d="M184.51,203.79V215c0,8.4-5.38,13.7-14.07,13.7-9.75,0-14.25-6.33-14.25-13.7V203.79c0-7.2,4.67-13.43,14.25-13.43C179.25,190.36,184.51,196,184.51,203.79ZM159,203.9v11.21c0,5.9,3.78,11.26,11.47,11.26,7,0,11.17-4.82,11.17-11.48v-11c0-6.28-4.14-11.16-11.17-11.16C162.81,192.74,159,197.89,159,203.9Z"
                    transform="translate(-0.46 -0.25)"
                />
                <path
                    className="fill-[#929497]"
                    d="M203.6,207.09c-2.95-4.06-5.85-8.07-8.75-12.18a.05.05,0,0,0-.06.05v33.36H192V190.63h2.83l15.25,21c3,4.17,6,8.34,8.93,12.51.06,0,.06,0,.06-.05V190.63h2.72v37.69H219Z"
                    transform="translate(-0.46 -0.25)"
                />
                <path
                    className="fill-[#231f20] dark:fill-white"
                    d="M23.24,73.62v2.55l.23.07c2.14-2.18,5.43-2.91,8.18-2.91,13.06,0,13.82,11,13.82,18.79,0,7.42-2.06,18-14.43,18-2.53,0-6-1.09-7.57-3.28l-.23.08v17.47H12.4V73.62Zm5.5,27c5.05,0,5.58-5,5.58-8.89,0-3.71-.23-9-5.58-9-5.19,0-5.5,5.46-5.5,9C23.24,95.39,23.7,100.64,28.74,100.64Z"
                    transform="translate(-0.46 -0.25)"
                />
                <path
                    className="fill-[#231f20] dark:fill-white"
                    d="M63.88,73.62V95c0,3.64,2.21,5.53,5.27,5.53S75,98.6,75,95V73.62H85.88v36H75v-3H74.8c-2.06,2.25-6.11,3.49-8.94,3.49-7.94,0-12.91-4.51-12.91-13V73.62Z"
                    transform="translate(-0.46 -0.25)"
                />
                <path
                    className="fill-[#231f20] dark:fill-white"
                    d="M105.89,88.26v21.48H95V73.62h10.7V77.7l.23.07a10.68,10.68,0,0,1,8.4-4.51,13.21,13.21,0,0,1,8,2.25l-3.82,9.11a13.53,13.53,0,0,0-7-1.9C108.25,82.72,105.89,84.62,105.89,88.26Z"
                    transform="translate(-0.46 -0.25)"
                />
                <path
                    className="fill-[#231f20] dark:fill-white"
                    d="M137.43,73.62v2.55l.23.07c2.14-2.18,5.42-2.91,8.17-2.91,13.06,0,13.83,11,13.83,18.79,0,7.42-2.07,18-14.44,18-2.52,0-6-1.09-7.56-3.28l-.23.08v17.47H126.58V73.62Zm5.5,27c5,0,5.58-5,5.58-8.89,0-3.71-.23-9-5.58-9-5.19,0-5.5,5.46-5.5,9C137.43,95.39,137.89,100.64,142.93,100.64Z"
                    transform="translate(-0.46 -0.25)"
                />
                <path
                    className="fill-[#231f20] dark:fill-white"
                    d="M178.75,109.66c-6.19,0-11.69-2.11-11.69-10.7V56.8H178V97c0,3.21,1.45,3.65,3.43,3.65h1.23v9Z"
                    transform="translate(-0.46 -0.25)"
                />
                <path
                    className="fill-[#231f20] dark:fill-white"
                    d="M198.3,94.37c.46,4.66,2.68,6.34,6.34,6.34a13.67,13.67,0,0,0,8.56-3.35l6.72,7.13a23.62,23.62,0,0,1-15.58,5.61C196,110.1,187,106.24,187,91.75c0-13.61,8.78-18.49,17.26-18.49,12,0,17.42,7.72,17.42,18.56v2.55Zm6-11.87a5.8,5.8,0,0,0-5.66,5.17h11.23A5.55,5.55,0,0,0,204.34,82.5Z"
                    transform="translate(-0.46 -0.25)"
                />
                <path
                    className="fill-[#231f20] dark:fill-white"
                    d="M94.51,170.21H85.34l-2.9-8.88-3.36-11h-.23l-3.29,10.92-3,9H63.42l-12.91-36H62.12l2.67,9,3,11.21h.38l3.44-11.21,3.06-9h8.7l3,9,3.36,11.21h.46l3-11.21,2.67-9h11.61Z"
                    transform="translate(-0.46 -0.25)"
                />
                <path
                    className="fill-[#231f20] dark:fill-white"
                    d="M132.54,170.21v-3.35l-.23-.07c-2.67,3-6.8,3.79-9.32,3.79-7.33,0-12.68-3.35-12.68-11.07,0-6.12,4.89-11.14,13.68-11.14h8.55V147.2c0-1.6-.69-4.36-6.34-4.36-3.44,0-6.42.72-8.94,2.83L112,138.61c4.59-3.93,10-4.8,15.36-4.8,8.78,0,16,2.76,16,12.3v24.1Zm0-14.27h-7.18c-3.89,0-4.58,1.6-4.58,2.7,0,.94.69,3.35,5.19,3.35,3.36,0,6.57-1.46,6.57-4.88Z"
                    transform="translate(-0.46 -0.25)"
                />
                <path
                    className="fill-[#231f20] dark:fill-white"
                    d="M170.73,170.21h-8.48l-14.89-36H159l3.36,9.68,4,12.09h.15l4-12.09,3.44-9.68h11.61Z"
                    transform="translate(-0.46 -0.25)"
                />
                <path
                    className="fill-[#231f20] dark:fill-white"
                    d="M198.3,154.92c.46,4.66,2.68,6.34,6.34,6.34a13.67,13.67,0,0,0,8.56-3.35l6.72,7.13a23.62,23.62,0,0,1-15.58,5.61c-8.33,0-17.34-3.86-17.34-18.35,0-13.62,8.78-18.49,17.26-18.49,12,0,17.42,7.71,17.42,18.56v2.55Zm6-11.87a5.8,5.8,0,0,0-5.66,5.17h11.23A5.55,5.55,0,0,0,204.34,143.05Z"
                    transform="translate(-0.46 -0.25)"
                />
                <path
                    className="fill-[#231f20] dark:fill-white"
                    d="M243,76.17a4,4,0,0,1-4,4,4,4,0,1,1,2.82-6.82A3.81,3.81,0,0,1,243,76.17Zm-.54,0a3.42,3.42,0,0,0-1-2.46,3.45,3.45,0,0,0-4.9,0,3.5,3.5,0,0,0,0,4.92,3.43,3.43,0,0,0,4.9,0A3.38,3.38,0,0,0,242.46,76.17Zm-.89,2h-1L239,76.56h-.75V78.2h-.76V74h1.44a7.1,7.1,0,0,1,.72,0,1.87,1.87,0,0,1,.55.18,1.1,1.1,0,0,1,.43.39,1,1,0,0,1,.14.56,1.09,1.09,0,0,1-.26.74,1.9,1.9,0,0,1-.72.48Zm-1.62-3a.6.6,0,0,0-.07-.3.45.45,0,0,0-.22-.21.76.76,0,0,0-.3-.1,2.29,2.29,0,0,0-.41,0h-.69V76h.59a2.47,2.47,0,0,0,.5,0,.88.88,0,0,0,.34-.15.7.7,0,0,0,.2-.26A.83.83,0,0,0,240,75.19Z"
                    transform="translate(-0.46 -0.25)"
                />
            </g>
        </svg>
    )
}
